import {Box, Link} from '@mui/material';
// import {useSearchBox} from 'react-instantsearch-hooks-web';
import Typography from '@wearesection/bandai-react-components/atoms/Typography';
import dynamic from 'next/dynamic';
import {useCallback, useEffect, useMemo, useState} from 'react';
import {usePageSetting} from '~/providers/page-context.provider';
import {highlight} from '~/utils';
import HtmlRenderer from '@wearesection/bandai-react-components/atoms/HtmlRenderer';

const ConnectedSearchBox = dynamic(() => import('./searchBoxWidget'), {
  ssr: false,
});

type IInstantSearchCustom = {
  handleCloseSearchForm: Function;
  isShowSearch: boolean;
  handleShowTrending: Function;
  dataSubMenuMemo: any;
  locale: string;

  dataTrending?: any;
};

const InstantSearchCustom = (props: IInstantSearchCustom) => {
  const {
    handleCloseSearchForm,
    isShowSearch,
    handleShowTrending,
    dataSubMenuMemo,
    locale,
    dataTrending,
  } = props;

  const {globalData} = usePageSetting();
  const [dataRecent, setDataRecent] = useState<string[]>([]);
  const [showRecent, setShowRecent] = useState<boolean>(true);
  const [dataTrendingState, setDataTrendingState] = useState<any>(dataTrending);
  const [dataResult, setDataResult] = useState<string[]>([]);
  const [valueSearch, setValueSearch] = useState<string>('');
  const [lengthValue, setLengthValue] = useState<number>(0);

  useEffect(() => {
    setDataTrendingState(dataTrending);
  }, [dataTrending]);

  useEffect(() => {
    const recentInLocal = localStorage.getItem('recent_local');
    if (recentInLocal) {
      const recentLocal = JSON.parse(recentInLocal) ?? [];
      const dataClone = [...recentLocal];
      const dataSplit = dataClone.splice(recentLocal.length > 5 ? recentLocal.length - 5 : 0);
      setShowRecent(true);
      setDataRecent(dataSplit.reverse());
    } else {
      setShowRecent(false);
    }
  }, []);

  const handleSetDataResult = (data: any) => {
    setDataResult(data);
  };

  const topTrendingAndCacheMemo = useMemo(
    () => (
      <Box
        sx={{
          width: '100%',
          maxWidth: {
            xl: '636px',
            lg: '463px',
            md: '286px',
            xs: '100%',
          },
          marginLeft: 'auto',
          marginRight: 'auto',
        }}
      >
        <Box
          sx={{
            padding: {
              xs: '0 46px',
              sm: '0 54px',
              md: '0',
            },
            display: 'flex',
            flexDirection: {
              xs: 'column',
              md: 'row',
            },
          }}
        >
          <Box
            sx={{
              maxWidth: '274px',
              width: '100%',
            }}
          >
            <Typography
              variant="p7"
              color={'#9F9F9F'}
              sx={{
                marginBottom: '8px',
              }}
              textTransform={undefined}
            >
              {dataSubMenuMemo?.propsSearch?.textTopTrending ?? 'Top Trending'}
            </Typography>

            <Box>
              {!!dataTrendingState.length &&
                dataTrendingState.map((item: any, idx: number) => (
                  <Typography
                    variant="p5"
                    textTransform={undefined}
                    key={idx}
                    sx={{
                      '& a': {
                        color: '#151515',
                        textDecoration: 'none',
                      },
                      marginBottom: '16px',
                      // width: 'fit-content',
                      // position: 'relative',
                      // overflow: 'hidden',
                      // textOverflow: 'ellipsis',
                      // display: '-webkit-box',
                      // lineClamp: '1',
                      // WebkitLineClamp: 1,
                      // WebkitBoxOrient: 'vertical',

                      // height: '26px',
                      '&::after': {
                        content: "' '",
                        position: 'absolute',
                        left: '0px',
                        bottom: '0px',
                        width: '0%',
                        transition: 'all 0.3s',
                        borderBottom: '1px solid #9F9F9F',
                      },
                      '&:hover': {
                        '&::after': {
                          width: '100%',
                        },
                      },
                    }}
                  >
                    <Link href={`/${locale}/store/search?q=${item?.title}`}>{item.title}</Link>
                  </Typography>
                ))}
            </Box>
          </Box>
          {!!dataRecent.length && showRecent && (
            <Box
              sx={{
                maxWidth: '274px',
                width: '100%',
                marginLeft: {
                  xs: '0px',
                  md: '32px',
                },
                marginTop: {
                  xs: ' 40px',
                  md: '0px',
                },
                position: 'relative',
              }}
            >
              <Box
                sx={{
                  position: 'absolute',
                  left: {
                    xs: 'calc(100% - 46px)',
                    md: '100%',
                  },
                  top: '0px',
                }}
              >
                <Typography
                  variant="p5"
                  color="#737373"
                  sx={{
                    whiteSpace: 'nowrap',
                    position: 'relative',
                    cursor: 'pointer',
                    width: 'fit-content',
                    marginBottom: {
                      xs: '16px',
                      ld: '0px',
                    },

                    '&::before': {
                      content: '" "',
                      position: 'absolute',
                      left: '0px',
                      bottom: '0px',
                      width: '100%',
                      borderBottom: '1px solid #737373',
                    },
                  }}
                  textTransform={undefined}
                  onClick={() => {
                    localStorage.removeItem('recent_local');
                    setShowRecent(false);
                  }}
                >
                  {dataSubMenuMemo?.propsSearch?.textClearAll ?? 'Clear all'}
                </Typography>
              </Box>
              <Typography
                variant="p7"
                color={'#9F9F9F'}
                sx={{
                  marginBottom: '8px',
                }}
                textTransform={undefined}
              >
                {dataSubMenuMemo?.propsSearch?.textRecent ?? 'Recent'}
              </Typography>

              <Box>
                {!!dataRecent.length &&
                  dataRecent.map((item: any, idx: number) => (
                    <Typography
                      variant="p5"
                      textTransform={undefined}
                      key={idx}
                      sx={{
                        '& a': {
                          color: '#151515',
                          textDecoration: 'none',
                        },
                        marginBottom: '16px',
                        width: 'fit-content',
                        position: 'relative',
                        overflow: 'hidden',
                        textOverflow: 'ellipsis',
                        display: '-webkit-box',
                        lineClamp: '1',
                        WebkitLineClamp: 1,
                        WebkitBoxOrient: 'vertical',

                        height: '26px',
                        '&::after': {
                          content: "' '",
                          position: 'absolute',
                          left: '0px',
                          bottom: '0px',
                          width: '0%',
                          transition: 'all 0.3s',
                          borderBottom: '1px solid #9F9F9F',
                        },
                        '&:hover': {
                          '&::after': {
                            width: '100%',
                          },
                        },
                      }}
                    >
                      <Link href={`/${locale}/store/search?q=${item}`}>{item}</Link>
                    </Typography>
                  ))}
              </Box>
            </Box>
          )}
        </Box>
      </Box>
    ),
    [dataRecent, showRecent, dataTrendingState]
  );

  const ResultElement = ({title, locale}: {title: string; locale: string}) => {
    if (highlight(valueSearch, title)) {
      return (
        <Box
          className="hit-title"
          sx={{
            '& .ais-Highlight-highlighted': {
              color: '#151515',
              fontWeight: '700',
              backgroundColor: 'transparent',
            },
            marginBottom: '16px',
            '&:hover': {
              '& p': {
                '&::after': {
                  width: '100%',
                },
              },
            },
          }}
        >
          <Typography
            variant="p5"
            textTransform={undefined}
            sx={{
              '& a': {
                fontWeight: '400',
                color: '#151515',
              },
              width: 'fit-content',
              position: 'relative',
              overflow: 'hidden',
              textOverflow: 'ellipsis',
              display: '-webkit-box',
              lineClamp: '1',
              WebkitLineClamp: 1,
              WebkitBoxOrient: 'vertical',

              height: '26px',
              '&::after': {
                content: "' '",
                position: 'absolute',
                left: '0px',
                bottom: '0px',
                width: '0%',
                transition: 'all 0.3s',
                borderBottom: '1px solid #9F9F9F',
              },
            }}
          >
            <Link
              sx={{
                '& span': {
                  fontWeight: '600 !important',
                },
              }}
              href={`/${locale}/store/search?q=${title}`}
            >
              {<HtmlRenderer component="div" value={highlight(valueSearch, title)} />}
            </Link>
          </Typography>
        </Box>
      );
    } else {
      return null;
    }
  };

  const ToSuggestion = useMemo(() => {
    if (!!dataResult.length && valueSearch.length > 2) {
      return (
        <Box
          sx={{
            width: '100%',
            maxWidth: {
              xl: '636px',
              lg: '463px',
              md: '286px',
              xs: '100%',
            },
            marginLeft: 'auto',
            marginRight: 'auto',
          }}
        >
          <Box
            sx={{
              '& .ais-Hits-list': {
                textDecoration: 'none',
                padding: '0px',
              },
              '& a': {
                textDecoration: 'none',
              },
              '& li': {
                listStyle: 'none !important',
              },
              padding: {
                xs: '0 46px',
                sm: '0 54px',
                md: '0',
              },
            }}
          >
            <Typography
              variant="p7"
              color={'#9F9F9F'}
              sx={{
                marginBottom: '8px',
              }}
              textTransform={undefined}
            >
              {dataSubMenuMemo?.propsSearch?.textTopSuggestion ?? 'Top suggestions'}
            </Typography>
            {!!dataResult.length &&
              dataResult.map((item: any, idx: number) => (
                <ResultElement key={idx} title={item} locale={locale} />
              ))}
            <Link href={`/${locale}/store/search?q=${valueSearch}`} sx={{}}>
              <Typography
                variant="p5"
                color="#737373"
                sx={{
                  position: 'relative',
                  cursor: 'pointer',
                  width: 'fit-content',
                  marginBottom: {
                    xs: '16px',
                    ld: '0px',
                  },

                  '&::before': {
                    content: '" "',
                    position: 'absolute',
                    left: '0px',
                    bottom: '0px',
                    width: '100%',
                    borderBottom: '1px solid #737373',
                  },
                }}
                textTransform={undefined}
              >
                {dataSubMenuMemo?.propsSearch?.textSeeAllResults ?? ' See all results'}
              </Typography>
            </Link>
          </Box>
        </Box>
      );
    } else {
      return null;
    }
  }, [valueSearch, dataResult]);

  return (
    <Box>
      <ConnectedSearchBox
        onClose={() => handleCloseSearchForm()}
        isShowSearch={isShowSearch}
        handleSetDataResult={handleSetDataResult}
        handleShowTrending={handleShowTrending}
        setValueSearch={setValueSearch}
        setLengthValue={setLengthValue}
        propsSearch={{
          ...dataSubMenuMemo.propsSearch,
          listResultDefault: [],
        }}
      />

      {/* Top suggestion */}
      {/* {!!dataResult.length && valueSearch.length > 2 && (

      )} */}
      {lengthValue > 2 && ToSuggestion}
      {/* Top Trending */}
      {(lengthValue <= 2 || !dataResult.length) && <Box>{topTrendingAndCacheMemo}</Box>}
    </Box>
  );
};

export default InstantSearchCustom;
